const doc = [({"da":({"js":({"admin":({"highscore_class_steps":({"table":({"the_class_step_was_removed_from_the_highscore":"Klassetrinet blev fjernet fra highscoren"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;